export default __webpack_public_path__ + "static/media/SourceSansPro-BoldItalic.ef8fdb1e.woff2";